import { FormControl, InputLabel, Select, MenuItem } from "@material-ui/core";
import React, { ChangeEvent, FC } from "react";

interface Props {
  value: number;
  error?: boolean;
  label: string;
  name: string;
  disabled?: boolean;
  options: Array<{ id?: string; label: string | number; value: number | string }>;
  onChange: (e: ChangeEvent<{ name?: string; value: unknown }>) => void;
}

export const SingleTimeSelect: FC<Props> = ({
  name,
  value,
  error,
  label,
  disabled,
  options,
  onChange,
}) => {
  return (
    <FormControl error={error}>
      <InputLabel>{label}</InputLabel>
      <Select onChange={onChange} value={value} disabled={disabled} name={name}>
        <MenuItem style={{ display: "none" }} />
        {options.map((it) => (
          <MenuItem key={it.id} value={it.value}>
            {it.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
